import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=07fbd126&scoped=true"
import script from "./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue?vue&type=script&lang=js"
import style0 from "./Gender.vue?vue&type=style&index=0&id=07fbd126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbd126",
  null
  
)

export default component.exports